import axios from "axios";

/**
 * Configured axios instance for the REST API client.
 *
 * Uses a custom paramsSerializer to handle array parameters without brackets.
 * This ensures arrays like `status: ['draft', 'sent']` are serialized as
 * `status=draft&status=sent` instead of `status[]=draft&status[]=sent`.
 *
 * Hono's query parser expects the non-bracket format for proper array handling.
 */
export const apiClient = axios.create({
  paramsSerializer: {
    serialize: (params) => {
      const searchParams = new URLSearchParams();

      for (const [key, value] of Object.entries(params)) {
        if (value === undefined || value === null) continue;

        if (Array.isArray(value)) {
          // Serialize arrays as repeated params: status=a&status=b
          for (const item of value) {
            if (item !== undefined && item !== null) {
              searchParams.append(key, String(item));
            }
          }
        } else if (value instanceof Date) {
          searchParams.append(key, value.toISOString());
        } else {
          searchParams.append(key, String(value));
        }
      }

      return searchParams.toString();
    },
  },
});

export default apiClient;
